import restApi from "../../http.js";
import session from "../session";

export default class Files {
  uploadFile(file) {
    return restApi({
      method: "POST",
      url: "/files",
      data: file,
      headers: {
        Authorization: "Bearer " + session.getAccessToken(),
      },
    });
  }
}
